// History
import { createBrowserHistory } from 'history';

// Export
export default createBrowserHistory();